<link rel="stylesheet" [href]='themeURL'>

<app-header class="navbar border-0"></app-header>
<div class="main-content">
  <router-outlet></router-outlet>
</div>